const PHONE_ALLOWED_REGEX = /^[+()\-\s.\d]+$/;

export const isValidPhoneNumber = (value: string) => {
  if (!PHONE_ALLOWED_REGEX.test(value)) {
    return false;
  }

  const digits = value.replace(/\D/g, '');
  return digits.length >= 7 && digits.length <= 15;
};
